import { Component, Input } from '@angular/core';
import { NavController, NavParams, ToastController, Events, ViewController } from 'ionic-angular';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { StoreWrapProvider } from '../../providers/store-wrap/store-wrap';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service';
@Component({
  selector: 'page-file-upload',
  templateUrl: 'file-upload.html',
})
export class FileUploadPage {
  @Input() params: any;
  @Input() accessType: any;
  @Input() field: any;
  @Input() isChildForm: any;
  @Input() screenProps: any;
  @Input() parentForm: any;
  @Input() sourceField: any;

  paramData: any;
  pdfUrl: SafeResourceUrl;
  templateName: any;
  documentName: any;
  Comment: any = '';
  version_id: any;
  fileAttachment: any;
  showFileUpload: any = false;
  version_name: any = '';
  fieldSet: any;
  internalParams: any = { "user_id": '', "document_id": '' };
  broadcastSubs: any;

  constructor(public communicationServ: CommunicationServiceProvider, public configApi: ConfigApiServiceProvider, public events: Events, public navCtrl: NavController, public navParams: NavParams, public sanitizer: DomSanitizer, public driveService: DriveServiceProvider, private storeWrap: StoreWrapProvider, public viewCtrl: ViewController, public toastController: ToastController, public spinnerService: Ng4LoadingSpinnerService) {

    this.templateName = driveService.objCurrentFolder['name'];

    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "grid") {
          if (data.event === 'documentName') {
            this.documentName = data['documentName'];
          }
        }
      })

    if (this.documentName == undefined || "") {
      this.documentName = "New Template";
    }
  }

  exitScreen() {
    this.viewCtrl.dismiss();
  }

  ngOnInit() {
    this.paramData = this.params;
    /* * * * * * * * * *
    * child form navparams
    * * * * * * * * * */
    if (this.navParams.get('chilFormParams')) {
      let chilFormParams = this.navParams.get('chilFormParams');
      this.field = chilFormParams['field'];
      this.params = chilFormParams['params'];
      this.isChildForm = chilFormParams['isChildForm'];
      this.screenProps = chilFormParams['screenProps'];
      this.parentForm = chilFormParams['parentForm'];
      this.sourceField = chilFormParams['sourceField'];
      this.fieldSet = this.screenProps.pushParams;
      this.internalParams['user_id'] = this.params.user_id
      this.internalParams['document_id'] = this.params.document_id;
      this.loadDocumentSummary()
    }
  }

  loadDocumentSummary() {
    let data: any = Object.assign({}, this.screenProps.pullParams, this.internalParams)
    this.driveService.pullSyncData(0, data, null, this.storeWrap.typeOfApi.summary, this.storeWrap.typeOfData.typeCustomApi, this.getSummaryData)
  }

  getSummaryData = ((data) => {
    if (data[0].length > 0) {
      data = data[0];
      // this.events.publish('reloadVersionHistory', true, this.internalParams); 
      if (data.length > 1) {
        this.fileAttachment = '';
      } else {
        this.fileAttachment = data[0]["attachments"];
        this.version_id = data[0]["version_id"];
      }
      this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.fileAttachment);
    }
  });

  openTemplateVersionHistory(e) {
    var file = e.target.files[0];
    if (file) {
      this.readFile(file);
    } else {
      const toast = this.toastController.create({
        message: 'Image Is Not Valid !!',
        duration: this.configApi.toastDuration
      });
      toast.present();
    }
  }
  readFile(file: any) {
    const reader = new FileReader();
    reader.onloadend = () => {
      const formData = new FormData();
      const imgBlob = new Blob([reader.result], {
        type: file.type
      });
      formData.append('file', imgBlob, file.name);
      this.uploadImageData(formData, this.loadPDF);
    };
    reader.readAsArrayBuffer(file);
  }

  async uploadImageData(formData, cbck) {
    this.spinnerService.show();
    var xhr = new XMLHttpRequest();
    var pdf_src = "";
    var url = "https://time.starport.ca:62226/phpupload/upload_file.php";
    xhr.open('POST', url, true);
    xhr.onload = function (e) {
      pdf_src = xhr.responseText;
      cbck(pdf_src);
    };
    xhr.onreadystatechange = function (aEvt) {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
        }
        else {
          alert("file size should be less than 2 MB !!");
        }
      }
    };
    xhr.send(formData);
  }

  loadPDF = ((file) => {
    var str = file.substring(0, 7);
    if (str === 'FAILED1') {
      this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(file);
      this.fileAttachment = '';
      const toast = this.toastController.create({
        message: 'file upload failed !!.',
        duration: this.configApi.toastDuration
      });
      toast.present();
    } else {
      this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(file);
      this.fileAttachment = file;
    }
  });

  submitFileUpload(e) {
    if (this.fileAttachment) {
      this.version_id = "";
      this.fieldSet['attachments'] = this.fileAttachment;
      this.fieldSet['version_id'] = this.version_id;
      this.fieldSet['attachments'] = this.fileAttachment;
      this.fieldSet['document_id'] = this.internalParams['document_id'];
      this.fieldSet['user_id'] = this.internalParams['user_id']
      let postData = this.fieldSet
      this.configApi.pushRequest(postData, this.response_Data);
    } else {
      this.exitScreen();
    }
  }

  response_Data = ((data) => {
    if (this.field.FieldDataType === "INLINE-EDIT") {
      this.parentForm.controls[this.field.FieldName].setValue(this.fileAttachment);
    }
    this.spinnerService.hide();
    const toast = this.toastController.create({
      message: 'file updated successfully.',
      duration: this.configApi.toastDuration
    });
    this.exitScreen();
    toast.present();
  });

  ngOnDestroy() {
  }

}



// WEBPACK FOOTER //
// ./src/pages/file-upload/file-upload.ts